import { defineStore } from 'pinia';

export const useSocketStore = defineStore('socket', {
    state: () => ({
        socket: null,
        /** True when private channel (user-X) has subscription_succeeded. Used to prioritize private over public channels. */
        privateChannelReady: false,
    }),

    getters: {
        getSocket: (state) => state.socket,
        getPrivateChannelReady: (state) => state.privateChannelReady,
    },

    actions: {
        setSocket(payload) {
            this.socket = payload.socket;
        },
        setPrivateChannelReady(ready) {
            this.privateChannelReady = !!ready;
        },
    }
});



